import { procedureTypes } from 'lib/constants/constants';
import { Capitalize, ia } from 'lib/helpers/utility';

export const renderType = ({ primary, secondary, tertiary } = {}) => {
  const typeMap = { primary: 'Primary', secondary: 'Secondary', tertiary: 'Tertiary' };

  return (
    Object.entries({ primary, secondary, tertiary })
      .filter(([_, value]) => ia(value))
      .map(([key]) => typeMap[key])
      .join(', ') || '-'
  );
};

export const renderItemType = (item) => {
  if (!item) return '';

  // Primary type
  if (item?.primary) {
    return renderType(item);
  }

  // If item is from a package
  if (item?.packageId) {
    return 'Service from package';
  }

  // If item is a package
  if (item?.procedures || item?.products) {
    return 'Package';
  }

  if (item?.quantity && item?.sales_count) {
    return 'Product';
  }

  const itemType = item?.type;
  const matchedType = procedureTypes?.find((p) => p?.value === itemType);

  if (matchedType?.label) {
    return matchedType.label;
  }

  // Default formatting
  return Capitalize((itemType || '').replace(/_/g, ' '));
};
